<script setup lang="ts">
import type { Article } from "~/types/article"

defineProps({
  title: {
    type: String,
    default: "Laster...",
  },
  restricted: {
    type: Boolean,
    default: false,
  },
  img: {
    type: Object as PropType<Article["img"]>,
    default: null,
  },
})
</script>
<template>
  <div
    class="relative flex w-full h-full overflow-clip rounded-xl bg-platform-paper font-national2condensed"
    :class="{
      'brightness-[85%]': restricted,
    }"
  >
    <h3
      class="absolute inset-0 z-10 flex items-center justify-center w-full h-full p-4 text-4xl font-medium text-white uppercase bg-black/50 font-national2compressed lg:text-6xl"
    >
      Intro: {{ title }}
    </h3>
    <img
      v-if="img && img.src"
      class="absolute object-cover w-full h-full"
      :src="img?.src"
      :alt="img?.alt"
    />
  </div>
</template>
